module.exports = "img/flags/PN.75cf41b.png";